<template>
    <slide-y-up-transition :duration="400+(index*100)" :delay="200+(index*100)">
      <div v-show="show" class="item-loyalty-rule">
        <!--custom first element - kill me! TODO refactor to api-->
        <img v-if="index == 1 && currentBrandName === 'Książęce'"
             src="/loyalty/rule1b.png"
             :alt="'Zasada ' + currentBrandName">
        <img v-else :src="image" :alt="'Zasada ' + currentBrandName">
        <!--custom first element - kill me! TODO refactor to api-->
        <p v-if="index == 1 && currentBrandName === 'Książęce'">
          Za każde 2,8 HL w KEG za dowolną markę (poza marką Żubr), uczestnik otrzyma 1 bon na KEG za 1 zł.
        </p>
        <p v-else>{{ title }}</p>
      </div>
    </slide-y-up-transition>
</template>

<script>
  import {mapState} from "vuex";

  export default {
    name: 'ItemLoyaltyRule',
    props: ['index', 'title', 'image'],
    data() {
      return {
        show: false
      }
    },
    computed: {
      ...mapState({
        currentBrandName: state => state.loyalty.currentBrandName
      }),
      currentImage(){
        return null
      }
    },
    mounted() {
      this.show = true
    }
  }
</script>

<style lang="scss" scoped>
  .item-loyalty-rule{
    margin: 10px 0;
    padding: 12px 15px;
    text-align: center;
    border: 1px solid #bfbfbf;
    img{
      display: inline-block;
      max-width: 220px;
      margin: 5px 0 0;
    }
  }
</style>